export default function ImpactReporth5(props) {
    const hyphenateAndLowercase = (str) => {
        // return str.replace(/\s+/g, '-').toLowerCase();
        return str
            .replace(/[^\w\s-]/g, '')   // Remove special characters except spaces and hyphens
            .replace(/\s+/g, '-')       // Replace spaces with hyphens
            .toLowerCase();
      }

    const id = hyphenateAndLowercase(props.children);

    return (
        <h5 
            id={id} 
            className={`impact-h5${props.className ? ' ' + props.className : ''}`}
            style={props.style}
        >
            {props.children}
        </h5>
    );

}